export default __webpack_public_path__ + "static/media/giftcard_place.a99e5a93.png";